import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getGalleryMetaSliceContent = createAsyncThunk('/galleryMetas/content', async () => {
	const response = await axios.post(`${API_URL}/getGalleryMetaData`);
    console.log(response.data);
	return response;
})

export const galleryMetaSlice = createSlice({
    name: 'galleryMetas',
    initialState: {
        isLoading: false,
        galleryMetas : []
    },
    reducers: {
    },
    extraReducers: {
		[getGalleryMetaSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getGalleryMetaSliceContent.fulfilled]: (state, action) => {
			state.galleryMetas = action.payload.data
			state.isLoading = false
		},
		[getGalleryMetaSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default galleryMetaSlice.reducer